// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EtIe82A{display:grid;gap:.75em;grid-template-columns:1.5em 1fr auto}@media(max-width: 899px){.EtIe82A{gap:.5em}}.Z0ks8dS{height:calc(3em + 2px);margin-bottom:1em}.Z0ks8dS [class*=InputText]{height:3em}.nlB640x,button.nlB640x{width:100% !important;height:2.222em;max-height:2.222em;font-family:var(--display-font-family);font-size:18px;font-weight:600}@media(max-width: 899px){.nlB640x,button.nlB640x{height:2.85em;max-height:2.85em;font-size:14px}}.KJlUYxI{width:1em;height:1em}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"applyRow": `EtIe82A`,
	"field": `Z0ks8dS`,
	"button": `nlB640x`,
	"loader": `KJlUYxI`
};
export default ___CSS_LOADER_EXPORT___;
